import React, { Component } from "react";

class Schedule extends Component {
  render() {
    return (
      <>
        <h2>Livestream schedule &amp; replays</h2>
        <p>Check our schedule to watch &amp; ask questions live!</p>
      </>
    );
  }
}

export default Schedule;
